import { BirthRecords, ProfileTypes, SocialSecurity } from "../..";

export interface FormData {
    /*
     * Common fields
     */
    firstName: string;
    middleName?: string;
    lastName: string;

    dateOfBirth: string;

    birthCity: string;
    birthState?: ProfileTypes.StateNotUnknown;

    fatherName?: string;
    fatherMaidenName?: string;

    motherName?: string;
    motherMaidenName?: string;

    /*
     * ID-type-specific
     */
    birthRecords?: Partial<BirthRecords.FormData>,
    socialSecurity?: Partial<SocialSecurity.FormData>
}